export default __webpack_public_path__ + "static/media/flag-zambia.671d04c2.svg";